import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AdminGuard implements CanActivate {

    constructor(
      private authenticationService: AuthenticationService,
      private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const currentUser = localStorage.getItem('currentUser');

      // Check if user is not logged in
      if (!currentUser) {
        this.router.navigate(['/pages/login'], { queryParams: { returnurl: state.url } });
        return false;
      }

      // Check that the user is an ADMIN user
      if (this.authenticationService.userIsAdmin()) {
        return true;
      }
      else {
        this.router.navigate(['/dashboard/all']);
        return false;
      }
    }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/guards/admin.guard.ts